import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=c2ac06a2&scoped=true&"
var script = {}
import style0 from "./Index.vue?vue&type=style&index=0&id=c2ac06a2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2ac06a2",
  null
  
)

export default component.exports